import React, { Component } from "react";
import {
  Card,
  Container,
  Row,
  Col,
  CardGroup,
  CardBody,
  Button,
  Alert,
  Badge,
} from "reactstrap";
import { connect } from "react-redux";
import { HashLoader } from "react-spinners";
import { Gmaps, Marker, InfoWindow, Circle } from "react-gmaps";
import moment from "moment";
import logoAutoma from "../../../assets/img/brand/new-automa-logo.png";
import { fetchTransporterShareTrack } from "../../../redux/actions/aTransporter-ShareTracker.jsx";
import { fetchWorkOrdersStockerInboundItemByWoTable } from "../../../redux/actions/aTransporter-WoStocker";
import { fetchWorkOrdersStockerOutboundItemByWoTable } from "../../../redux/actions/aTransporter-WoStocker";
import CheckOutboundItemTable from "../../Widgets/CheckOutboundItemTable";
import customMarker from "../../../assets/img/truck.png";
import photoNotFound from "../../../assets/img/photo_not_found.png";

const params = {
  v: "3.exp",
  key: "AIzaSyCmIATqobqbCEU90nYtwd-PzCcj8EVOlDg",
};
class TrackerDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount = () => {
    //console.log(this.props.match.params.id)
    this.props.fetchTransporterShareTrack(this.props.match.params.id);
  };

  componentDidUpdate(prevProps) {
    const { transporterShareTrackData } = this.props;
    if (
      JSON.stringify(prevProps.transporterShareTrackData) !==
      JSON.stringify(transporterShareTrackData)
    ) {
      this.props.fetchWorkOrdersStockerInboundItemByWoTable(
        transporterShareTrackData[0].result
      );
      this.props.fetchWorkOrdersStockerOutboundItemByWoTable(
        transporterShareTrackData[0].result
      );
    }
  }

  updateYear = () => {
    var d = new Date();
    var n = d.getFullYear();
    return n;
  };

  dateFormatter = (_data) => {
    var date = moment(_data).format("DD-MMM-YYYY HH:mm:ss");
    if (date !== "Invalid date") {
      return date;
    } else {
      return "Time limit exceeded";
    }
  };

  toTitleCase = (text) => {
    text = text
      .toLowerCase()
      .split(" ")
      .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
      .join(" ");

    return text;
  };

  checkDataShow = () => {
    const {
      transporterShareTrackData,
      driverVac,
      asstVac,
      woInboundData,
      woOutboundData,
    } = this.props;
    //console.log(transporterShareTrackData)
    if (
      (transporterShareTrackData !== [] ||
        transporterShareTrackData !== "" ||
        transporterShareTrackData !== null) &&
      woInboundData &&
      woOutboundData
    ) {
      return transporterShareTrackData.map((data) => {
        const driverName = this.toTitleCase(
          data.delivery_order_details
            ? data.delivery_order_details[0].driver_name
            : ""
        );
        const driverAssistantName = this.toTitleCase(
          data.delivery_order_details
            ? data.delivery_order_details[0].driver_assistant_name
            : ""
        );
        const driverPhoto = data.delivery_order_details
          ? data.delivery_order_details[0].driver_photo_link
            ? encodeURI(data.delivery_order_details[0].driver_photo_link)
            : photoNotFound
          : null;
        const driverAssistantPhoto = data.delivery_order_details
          ? data.delivery_order_details[0].driver_assist_photo_link
            ? encodeURI(data.delivery_order_details[0].driver_assist_photo_link)
            : photoNotFound
          : null;
        // var driverVac = data.driver_vac_details.length > 0 ? true : false
        // var asstVac = data.assist_vac_detail.length > 0 ? true : false
        if (data.kampret_condition === true) {
          // Kampret Condition True
          if (data.result[0].timeCheckIn !== null) {
            return (
              // State 3
              <Card>
                <Alert color="success" style={{ marginBottom: 0 }}>
                  Your package maybe near or almost delivered to your address.
                </Alert>
                <Gmaps
                  width="100%"
                  height="300px"
                  lat={data.result[0].work_order_from.lat}
                  lng={data.result[0].work_order_from.lng}
                  zoom={16}
                  loadingMessage={
                    "Please wait while we're preparing this for you..."
                  }
                  params={params}
                  onMapCreated={this.onMapCreated}
                >
                  {/* For Truck Position */}
                  <Marker
                    options={{ icon: customMarker }}
                    lat={data.fleet_status.lat}
                    lng={data.fleet_status.lon}
                    draggable={true}
                    onDragEnd={this.onDragEnd}
                  />
                  <InfoWindow
                    lat={data.fleet_status.lat + 0.0008}
                    lng={data.fleet_status.lon}
                    content={
                      "<strong>Fleet Location<br/>Lat: </strong>" +
                      data.fleet_status.lat +
                      "<strong>,<br/> Long: </strong>" +
                      data.fleet_status.lon +
                      "<strong>,<br/> Reg. Number: </strong>" +
                      data.fleet_reg_number +
                      '<br/><br/><img width="40" height="45" style="border-radius: 50%; display: inline-block; vertical-align:top;" src=' +
                      driverPhoto +
                      ' /> <div style="display: inline-block;"> <strong>Driver Name: </strong><p>' +
                      driverName +
                      "</p></div>" +
                      '<br/><br/><img width="40" height="45" style="border-radius: 50%; display: inline-block; vertical-align:top;" src=' +
                      driverAssistantPhoto +
                      ' /> <div style="display: inline-block;"> <strong>Asst. Name: </strong><p>' +
                      driverAssistantName +
                      " Snow</p></div>"
                    }
                    onCloseClick={this.onCloseClick}
                  />
                  <Circle
                    lat={data.fleet_status.lat}
                    lng={data.fleet_status.lon}
                    radius={100}
                    // onClick={this.onClick}
                  />
                  {/* For Warehouse Position */}
                  <Marker
                    lat={data.result[0].work_order_from.lat}
                    lng={data.result[0].work_order_from.lng}
                    draggable={true}
                    onDragEnd={this.onDragEnd}
                  />
                </Gmaps>
                <Alert color="primary">
                  <Row>
                    <Col md="6">
                      <dt>Driver Name</dt>
                      <dd>
                        {data.driver_name ? data.driver_name : "-"}{" "}
                        {driverVac > 0 ? (
                          <Badge size="sm" color="success">
                            Vaccinated
                          </Badge>
                        ) : (
                          true
                        )}
                        {/* {isVaccine} */}
                      </dd>
                      <dt>Driver Assistant Name</dt>
                      <dd>
                        {driverAssistantName ? driverAssistantName : "-"}{" "}
                        {asstVac > 0 ? (
                          <Badge size="sm" color="success">
                            Vaccinated
                          </Badge>
                        ) : (
                          true
                        )}
                        {/* {isVaccine} */}
                      </dd>
                    </Col>
                    <Col md="6">
                      <dt>Transporter</dt>
                      <dd>
                        {data.result[0].work_order_from.company_delivery
                          ? data.result[0].work_order_from.company_delivery
                          : "-"}
                      </dd>
                      <dt>Shipper</dt>
                      <dd>
                        {data.result[0].work_order_from.company_requestor
                          ? data.result[0].work_order_from.company_requestor
                          : data.result[0].work_order_from.company_delivery
                          ? data.result[0].work_order_from.company_delivery
                          : "-"}
                      </dd>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <dt>Fleet Id</dt>
                      <dd>
                        {data.fleet_reg_number ? data.fleet_reg_number : "-"}
                      </dd>
                    </Col>
                    <Col md="6">
                      <dt>Loading Time</dt>
                      <dd>
                        {data.result[0].loadingTime
                          ? data.result[0].loadingTime + " min"
                          : "0 min"}
                      </dd>
                    </Col>
                  </Row>
                </Alert>
                <Row className="container">
                  <Col md="6">
                    <h6>Work Order Information</h6>
                    <dt>WO Number</dt>
                    <dd>
                      {data.result[0].work_order_from.wo_number
                        ? data.result[0].work_order_from.wo_number
                        : "-"}
                    </dd>

                    <dt>WO Sequence</dt>
                    <dd>
                      {data.result[0].work_order_from.wo_seq
                        ? data.result[0].work_order_from.wo_seq
                        : "-"}
                    </dd>

                    <dt>WO Description</dt>
                    <dd>
                      {data.result[0].work_order_from.wo_desc
                        ? data.result[0].work_order_from.wo_desc
                        : "-"}
                    </dd>

                    <dt>WO Destination name</dt>
                    <dd>
                      {data.result[0].work_order_from.wo_destination_name
                        ? data.result[0].work_order_from.wo_destination_name
                        : "-"}
                    </dd>

                    <dt>WO Address</dt>
                    <dd style={{ textAlign: "justify" }}>
                      {data.result[0].work_order_from.wo_address
                        ? data.result[0].work_order_from.wo_address
                        : "-"}
                    </dd>
                  </Col>
                  <Col md="6">
                    <h6>Time-related Information</h6>
                    <dt>Distance</dt>
                    <dd>
                      {data.result[0].work_order_from.distance
                        ? data.result[0].work_order_from.distance + " KM"
                        : "-"}
                    </dd>

                    <dt>Est. Departure Time</dt>
                    <dd>
                      {data.result[0].work_order_from.est_departure_time
                        ? this.dateFormatter(
                            data.result[0].work_order_from.est_departure_time
                          )
                        : "-"}
                    </dd>

                    <dt>Est. Arrival Time</dt>
                    <dd>
                      {data.result[0].work_order_from.est_arrival_time
                        ? this.dateFormatter(
                            data.result[0].work_order_from.est_arrival_time
                          )
                        : "-"}
                    </dd>

                    <dt>Check-in Time</dt>
                    <dd>
                      {data.result[0].work_order_from.timeCheckIn
                        ? this.dateFormatter(
                            data.result[0].work_order_from.timeCheckIn
                          )
                        : "-"}
                    </dd>

                    <dt>Check-out Time</dt>
                    <dd>
                      {data.result[0].work_order_from.timeCheckOut
                        ? this.dateFormatter(
                            data.result[0].work_order_from.timeCheckOut
                          )
                        : "-"}
                    </dd>
                  </Col>
                  <Col md="12">
                    {data.result[0].work_order_from.id_inbound_stocker ||
                    data.result[0].work_order_from.id_outbound_stocker ? (
                      <React.Fragment>
                        <dt>Delivery Item(s)</dt>
                        <dd>
                          <CheckOutboundItemTable
                            showTable={true}
                            idInboundStocker={
                              data.result[0].work_order_from.id_inbound_stocker
                            }
                            idOutboundStocker={
                              data.result[0].work_order_from.id_outbound_stocker
                            }
                            inboundItem={
                              woInboundData[
                                data.result[0].work_order_from
                                  .id_inbound_stocker
                              ]
                                ? woInboundData[
                                    data.result[0].work_order_from
                                      .id_inbound_stocker
                                  ]
                                : null
                            }
                            outboundItem={
                              woOutboundData[
                                data.result[0].work_order_from
                                  .id_outbound_stocker
                              ]
                                ? woOutboundData[
                                    data.result[0].work_order_from
                                      .id_outbound_stocker
                                  ]
                                : null
                            }
                          />
                        </dd>
                      </React.Fragment>
                    ) : null}
                  </Col>
                </Row>
                <Alert color="success" style={{ marginBottom: 0 }}>
                  <Row>
                    <Col md="6">
                      <dt>PIC Name</dt>
                      <dd>
                        {data.result[0].work_order_from.pic_name
                          ? data.result[0].work_order_from.pic_name
                          : "-"}
                      </dd>
                    </Col>
                    <Col md="6">
                      <dt>PIC Phone</dt>
                      <dd>
                        {data.result[0].work_order_from.pic_phone
                          ? data.result[0].work_order_from.pic_phone
                          : "-"}
                      </dd>
                    </Col>
                  </Row>
                </Alert>
              </Card>
            );
          } else {
            // State 2
            return (
              <Card>
                <Alert color="primary" style={{ marginBottom: 0 }}>
                  Courier is delivering your package.
                </Alert>
                <Gmaps
                  width="100%"
                  height="300px"
                  lat={data.fleet_status.lat}
                  lng={data.fleet_status.lon}
                  zoom={16}
                  loadingMessage={
                    "Please wait while we're preparing this for you..."
                  }
                  params={params}
                  onMapCreated={this.onMapCreated}
                >
                  {/* For Truck Position */}
                  <Marker
                    options={{ icon: customMarker }}
                    lat={data.fleet_status.lat}
                    lng={data.fleet_status.lon}
                    draggable={true}
                    onDragEnd={this.onDragEnd}
                  />
                  <InfoWindow
                    lat={data.fleet_status.lat + 0.0008}
                    lng={data.fleet_status.lon}
                    content={
                      "<strong>Fleet Location<br/>Lat: </strong>" +
                      data.fleet_status.lat +
                      "<strong>,<br/> Long: </strong>" +
                      data.fleet_status.lon +
                      "<strong>,<br/> Reg. Number: </strong>" +
                      data.fleet_reg_number +
                      '<br/><br/><img width="40" height="45"style="border-radius: 50%; display: inline-block; vertical-align:top;" src=' +
                      driverPhoto +
                      ' /> <div style="display: inline-block;"> <strong>Driver Name: </strong><p>' +
                      driverName +
                      "</p></div>" +
                      '<br/><br/><img width="40" height="45"style="border-radius: 50%; display: inline-block; vertical-align:top;" src=' +
                      driverAssistantPhoto +
                      ' /> <div style="display: inline-block;"> <strong>Asst. Name: </strong><p>' +
                      driverAssistantName +
                      " Snow</p></div>"
                    }
                    onCloseClick={this.onCloseClick}
                  />
                  <Circle
                    lat={data.fleet_status.lat}
                    lng={data.fleet_status.lon}
                    radius={100}
                    // onClick={this.onClick}
                  />
                  {/* For Warehouse Position */}
                  <Marker
                    lat={data.result[0].work_order_from.lat}
                    lng={data.result[0].work_order_from.lng}
                    draggable={true}
                    onDragEnd={this.onDragEnd}
                  />
                </Gmaps>
                <Alert color="success">
                  <Row>
                    <Col md="6">
                      <dt>Driver Name</dt>
                      <dd>
                        {data.driver_name ? data.driver_name : "-"}{" "}
                        {driverVac > 0 ? (
                          <Badge size="sm" color="success">
                            Vaccinated
                          </Badge>
                        ) : (
                          true
                        )}
                      </dd>
                      <dt>Driver Assistant Name</dt>
                      <dd>
                        {driverAssistantName ? driverAssistantName : "-"}{" "}
                        {asstVac > 0 ? (
                          <Badge size="sm" color="success">
                            Vaccinated
                          </Badge>
                        ) : (
                          true
                        )}
                        {/* {isVaccine} */}
                      </dd>
                    </Col>
                    <Col md="6">
                      <dt>Transporter</dt>
                      <dd>
                        {data.result[0].work_order_from.company_delivery
                          ? data.result[0].work_order_from.company_delivery
                          : "-"}
                      </dd>
                      <dt>Shipper</dt>
                      <dd>
                        {data.result[0].work_order_from.company_requestor
                          ? data.result[0].work_order_from.company_requestor
                          : data.result[0].work_order_from.company_delivery
                          ? data.result[0].work_order_from.company_delivery
                          : "-"}
                      </dd>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <dt>Fleet Id</dt>
                      <dd>
                        {data.fleet_reg_number ? data.fleet_reg_number : "-"}
                      </dd>
                    </Col>
                    <Col md="6">
                      <dt>Loading Time</dt>
                      <dd>
                        {data.result[0].loadingTime
                          ? data.result[0].loadingTime + " min"
                          : "0 min"}
                      </dd>
                    </Col>
                  </Row>
                </Alert>
                <Row className="container">
                  <Col md="6">
                    <h6>Work Order Information</h6>
                    <dt>WO Number</dt>
                    <dd>
                      {data.result[0].work_order_from.wo_number
                        ? data.result[0].work_order_from.wo_number
                        : "-"}
                    </dd>

                    <dt>WO Sequence</dt>
                    <dd>
                      {data.result[0].work_order_from.wo_seq
                        ? data.result[0].work_order_from.wo_seq
                        : "-"}
                    </dd>

                    <dt>WO Description</dt>
                    <dd>
                      {data.result[0].work_order_from.wo_desc
                        ? data.result[0].work_order_from.wo_desc
                        : "-"}
                    </dd>

                    <dt>WO Destination name</dt>
                    <dd>
                      {data.result[0].work_order_from.wo_destination_name
                        ? data.result[0].work_order_from.wo_destination_name
                        : "-"}
                    </dd>

                    <dt>WO Address</dt>
                    <dd style={{ textAlign: "justify" }}>
                      {data.result[0].work_order_from.wo_address
                        ? data.result[0].work_order_from.wo_address
                        : "-"}
                    </dd>
                  </Col>
                  <Col md="6">
                    <h6>Time-related Information</h6>
                    <dt>Distance</dt>
                    <dd>
                      {data.result[0].work_order_from.distance
                        ? data.result[0].work_order_from.distance + " KM"
                        : "-"}
                    </dd>

                    <dt>Est. Departure Time</dt>
                    <dd>
                      {data.result[0].work_order_from.est_departure_time
                        ? this.dateFormatter(
                            data.result[0].work_order_from.est_departure_time
                          )
                        : "-"}
                    </dd>

                    <dt>Est. Arrival Time</dt>
                    <dd>
                      {data.result[0].work_order_from.est_arrival_time
                        ? this.dateFormatter(
                            data.result[0].work_order_from.est_arrival_time
                          )
                        : "-"}
                    </dd>

                    <dt>Check-in Time</dt>
                    <dd>
                      {data.result[0].timeCheckIn
                        ? this.dateFormatter(data.result[0].timeCheckIn)
                        : "-"}
                    </dd>

                    <dt>Check-out Time</dt>
                    <dd>
                      {data.result[0].timeCheckOut
                        ? this.dateFormatter(data.result[0].timeCheckOut)
                        : "-"}
                    </dd>
                  </Col>
                  <Col md="12">
                    {data.result[0].work_order_from.id_inbound_stocker ||
                    data.result[0].work_order_from.id_outbound_stocker ? (
                      <React.Fragment>
                        <dt>Delivery Item(s)</dt>
                        <dd>
                          <CheckOutboundItemTable
                            showTable={true}
                            idInboundStocker={
                              data.result[0].work_order_from.id_inbound_stocker
                            }
                            idOutboundStocker={
                              data.result[0].work_order_from.id_outbound_stocker
                            }
                            inboundItem={
                              woInboundData[
                                data.result[0].work_order_from
                                  .id_inbound_stocker
                              ]
                                ? woInboundData[
                                    data.result[0].work_order_from
                                      .id_inbound_stocker
                                  ]
                                : null
                            }
                            outboundItem={
                              woOutboundData[
                                data.result[0].work_order_from
                                  .id_outbound_stocker
                              ]
                                ? woOutboundData[
                                    data.result[0].work_order_from
                                      .id_outbound_stocker
                                  ]
                                : null
                            }
                          />
                        </dd>
                      </React.Fragment>
                    ) : null}
                  </Col>
                </Row>
                <br />
                <Alert color="success" style={{ marginBottom: 0 }}>
                  <Row>
                    <Col md="6">
                      <dt>PIC Name</dt>
                      <dd>
                        {data.result[0].work_order_from.pic_name
                          ? data.result[0].work_order_from.pic_name
                          : "-"}
                      </dd>
                    </Col>
                    <Col md="6">
                      <dt>PIC Phone</dt>
                      <dd>
                        {data.result[0].work_order_from.pic_phone
                          ? data.result[0].work_order_from.pic_phone
                          : "-"}
                      </dd>
                    </Col>
                  </Row>
                </Alert>
              </Card>
            );
          }
        } else {
          //Kampret Condition False
          if (data.result.length === 0) {
            return (
              <Alert color="success">
                Your package delivery tracking link already obsolete. Please
                contact your supplier/logistic to verify delivery status. Thank
                you for trusting Automa ID as your one and only only Supply
                Chain and Logistics Management Solution.
              </Alert>
            );
          } else {
            if (data.result[0].timeCheckIn === null) {
              // State 1
              return (
                <Card>
                  <Alert color="primary" style={{ marginBottom: 0 }}>
                    Your package has been manifested by the courier company.
                  </Alert>
                  <Gmaps
                    width="100%"
                    height="300px"
                    lat={data.fleet_status.lat}
                    lng={data.fleet_status.lon}
                    zoom={16}
                    loadingMessage={
                      "Please wait while we're preparing this for you..."
                    }
                    params={params}
                    onMapCreated={this.onMapCreated}
                  >
                    {/* For Truck Position */}
                    {/* <Marker
                                            options={{icon: customMarker}}
                                            lat={transporterShareTrackData.fleet_status.lat}
                                            lng={transporterShareTrackData.fleet_status.lon}
                                            draggable={true}
                                            onDragEnd={this.onDragEnd}
                                        />
                                        <InfoWindow
                                            lat={transporterShareTrackData.fleet_status.lat+0.0008}
                                            lng={transporterShareTrackData.fleet_status.lon}
                                            content={"<strong>Fleet Location<br/>Lat: </strong>"+transporterShareTrackData.fleet_status.lat+"<strong>,<br/> Long: </strong>"+transporterShareTrackData.fleet_status.lon}
                                            onCloseClick={this.onCloseClick}
                                        /> */}
                    <Circle
                      lat={data.fleet_status.lat}
                      lng={data.fleet_status.lon}
                      radius={12500}
                      // onClick={this.onClick}
                    />
                    {/* For Warehouse Position */}
                    <Marker
                      lat={data.result[0].work_order_from.lat}
                      lng={data.result[0].work_order_from.lng}
                      draggable={true}
                      onDragEnd={this.onDragEnd}
                    />
                  </Gmaps>
                  <Alert color="primary">
                    <Row>
                      <Col md="6">
                        <dt>Driver Name</dt>
                        <dd>
                          {data.driver_name ? data.driver_name : "-"}{" "}
                          {driverVac > 0 ? (
                            <Badge size="sm" color="success">
                              Vaccinated
                            </Badge>
                          ) : (
                            true
                          )}{" "}
                        </dd>
                        <dt>Driver Assistant Name</dt>
                        <dd>
                          {driverAssistantName ? driverAssistantName : "-"}{" "}
                          {asstVac > 0 ? (
                            <Badge size="sm" color="success">
                              Vaccinated
                            </Badge>
                          ) : (
                            true
                          )}
                        </dd>
                      </Col>
                      <Col md="6">
                        <dt>Transporter</dt>
                        <dd>
                          {data.result[0].work_order_from.company_delivery
                            ? data.result[0].work_order_from.company_delivery
                            : "-"}
                        </dd>
                        <dt>Shipper</dt>
                        <dd>
                          {data.result[0].work_order_from.company_requestor
                            ? data.result[0].work_order_from.company_requestor
                            : data.result[0].work_order_from.company_delivery
                            ? data.result[0].work_order_from.company_delivery
                            : "-"}
                        </dd>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6">
                        <dt>Fleet Id</dt>
                        <dd>
                          {data.fleet_reg_number ? data.fleet_reg_number : "-"}
                        </dd>
                      </Col>
                      <Col md="6">
                        <dt>Loading Time</dt>
                        <dd>
                          {data.result[0].loadingTime
                            ? data.result[0].loadingTime + " min"
                            : "0 min"}
                        </dd>
                      </Col>
                    </Row>
                  </Alert>
                  <Row className="container">
                    <Col md="6">
                      <h6>Work Order Information</h6>
                      <dt>WO Number</dt>
                      <dd>
                        {data.result[0].work_order_from.wo_number
                          ? data.result[0].work_order_from.wo_number
                          : "-"}
                      </dd>

                      <dt>WO Sequence</dt>
                      <dd>
                        {data.result[0].work_order_from.wo_seq
                          ? data.result[0].work_order_from.wo_seq
                          : "-"}
                      </dd>

                      <dt>WO Description</dt>
                      <dd>
                        {data.result[0].work_order_from.wo_desc
                          ? data.result[0].work_order_from.wo_desc
                          : "-"}
                      </dd>

                      <dt>WO Destination name</dt>
                      <dd>
                        {data.result[0].work_order_from.wo_destination_name
                          ? data.result[0].work_order_from.wo_destination_name
                          : "-"}
                      </dd>

                      <dt>WO Address</dt>
                      <dd style={{ textAlign: "justify" }}>
                        {data.result[0].work_order_from.wo_address
                          ? data.result[0].work_order_from.wo_address
                          : "-"}
                      </dd>
                    </Col>
                    <Col md="6">
                      <h6>Time-related Information</h6>
                      <dt>Distance</dt>
                      <dd>
                        {data.result[0].work_order_from.distance
                          ? data.result[0].work_order_from.distance + " KM"
                          : "-"}
                      </dd>

                      <dt>Est. Departure Time</dt>
                      <dd>
                        {data.result[0].work_order_from.est_departure_time
                          ? this.dateFormatter(
                              data.result[0].work_order_from.est_departure_time
                            )
                          : "-"}
                      </dd>

                      <dt>Est. Arrival Time</dt>
                      <dd>
                        {data.result[0].work_order_from.est_arrival_time
                          ? this.dateFormatter(
                              data.result[0].work_order_from.est_arrival_time
                            )
                          : "-"}
                      </dd>

                      <dt>Check-in Time</dt>
                      <dd>
                        {data.result[0].timeCheckIn
                          ? this.dateFormatter(data.result[0].timeCheckIn)
                          : "-"}
                      </dd>

                      <dt>Check-out Time</dt>
                      <dd>
                        {data.result[0].timeCheckOut
                          ? this.dateFormatter(data.result[0].timeCheckOut)
                          : "-"}
                      </dd>
                    </Col>
                    <Col md="12">
                      {data.result[0].work_order_from.id_inbound_stocker ||
                      data.result[0].work_order_from.id_outbound_stocker ? (
                        <React.Fragment>
                          <dt>Delivery Item(s)</dt>
                          <dd>
                            <CheckOutboundItemTable
                              showTable={true}
                              idInboundStocker={
                                data.result[0].work_order_from
                                  .id_inbound_stocker
                              }
                              idOutboundStocker={
                                data.result[0].work_order_from
                                  .id_outbound_stocker
                              }
                              inboundItem={
                                woInboundData[
                                  data.result[0].work_order_from
                                    .id_inbound_stocker
                                ]
                                  ? woInboundData[
                                      data.result[0].work_order_from
                                        .id_inbound_stocker
                                    ]
                                  : null
                              }
                              outboundItem={
                                woOutboundData[
                                  data.result[0].work_order_from
                                    .id_outbound_stocker
                                ]
                                  ? woOutboundData[
                                      data.result[0].work_order_from
                                        .id_outbound_stocker
                                    ]
                                  : null
                              }
                            />
                          </dd>
                        </React.Fragment>
                      ) : null}
                    </Col>
                  </Row>
                  <br />
                  <Alert color="success" style={{ marginBottom: 0 }}>
                    <Row>
                      <Col md="6">
                        <dt>PIC Name</dt>
                        <dd>
                          {data.result[0].work_order_from.pic_name
                            ? data.result[0].work_order_from.pic_name
                            : "-"}
                        </dd>
                      </Col>
                      <Col md="6">
                        <dt>PIC Phone</dt>
                        <dd>
                          {data.result[0].work_order_from.pic_phone
                            ? data.result[0].work_order_from.pic_phone
                            : "-"}
                        </dd>
                      </Col>
                    </Row>
                  </Alert>
                </Card>
              );
            } else {
              // State 4
              return (
                // State 3
                <Card>
                  <Alert color="success" style={{ marginBottom: 0 }}>
                    Your package maybe near or almost delivered to your address.
                  </Alert>
                  <Gmaps
                    width="100%"
                    height="300px"
                    lat={data.result[0].work_order_from.lat}
                    lng={data.result[0].work_order_from.lng}
                    zoom={16}
                    loadingMessage={
                      "Please wait while we're preparing this for you..."
                    }
                    params={params}
                    onMapCreated={this.onMapCreated}
                  >
                    {/* For Truck Position */}
                    <Marker
                      options={{ icon: customMarker }}
                      lat={data.fleet_status.lat}
                      lng={data.fleet_status.lon}
                      draggable={true}
                      onDragEnd={this.onDragEnd}
                    />
                    <InfoWindow
                      lat={data.fleet_status.lat + 0.0008}
                      lng={data.fleet_status.lon}
                      content={
                        "<strong>Fleet Location<br/>Lat: </strong>" +
                        data.fleet_status.lat +
                        "<strong>,<br/> Long: </strong>" +
                        data.fleet_status.lon +
                        "<strong>,<br/> Reg. Number: </strong>" +
                        data.fleet_reg_number +
                        '<br/><br/><img width="40" height="45" style="border-radius: 50%; display: inline-block; vertical-align:top;" src=' +
                        driverPhoto +
                        ' /> <div style="display: inline-block;"> <strong>Driver Name: </strong><p>' +
                        driverName +
                        "</p></div>" +
                        '<br/><br/><img width="40" height="45" style="border-radius: 50%; display: inline-block; vertical-align:top;" src=' +
                        driverAssistantPhoto +
                        ' /> <div style="display: inline-block;"> <strong>Asst. Name: </strong><p>' +
                        driverAssistantName +
                        " Snow</p></div>"
                      }
                      onCloseClick={this.onCloseClick}
                    />
                    <Circle
                      lat={data.fleet_status.lat}
                      lng={data.fleet_status.lon}
                      radius={100}
                      // onClick={this.onClick}
                    />
                    {/* For Warehouse Position */}
                    <Marker
                      lat={data.result[0].work_order_from.lat}
                      lng={data.result[0].work_order_from.lng}
                      draggable={true}
                      onDragEnd={this.onDragEnd}
                    />
                  </Gmaps>
                  <Alert color="primary">
                    <Row>
                      <Col md="6">
                        <dt>Driver Name</dt>
                        <dd>
                          {data.driver_name ? data.driver_name : "-"}{" "}
                          {driverVac > 0 ? (
                            <Badge size="sm" color="success">
                              Vaccinated
                            </Badge>
                          ) : (
                            true
                          )}{" "}
                        </dd>
                        <dt>Driver Assistant Name</dt>
                        <dd>
                          {driverAssistantName ? driverAssistantName : "-"}{" "}
                          {asstVac > 0 ? (
                            <Badge size="sm" color="success">
                              Vaccinated
                            </Badge>
                          ) : (
                            true
                          )}
                        </dd>
                      </Col>
                      <Col md="6">
                        <dt>Transporter</dt>
                        <dd>
                          {data.result[0].work_order_from.company_delivery
                            ? data.result[0].work_order_from.company_delivery
                            : "-"}
                        </dd>
                        <dt>Shipper</dt>
                        <dd>
                          {data.result[0].work_order_from.company_requestor
                            ? data.result[0].work_order_from.company_requestor
                            : data.result[0].work_order_from.company_delivery
                            ? data.result[0].work_order_from.company_delivery
                            : "-"}
                        </dd>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6">
                        <dt>Fleet Id</dt>
                        <dd>
                          {data.fleet_reg_number ? data.fleet_reg_number : "-"}
                        </dd>
                      </Col>
                      <Col md="6">
                        <dt>Loading Time</dt>
                        <dd>
                          {data.result[0].loadingTime
                            ? data.result[0].loadingTime + " min"
                            : "0 min"}
                        </dd>
                      </Col>
                    </Row>
                  </Alert>
                  <Row className="container">
                    <Col md="6">
                      <h6>Work Order Information</h6>
                      <dt>WO Number</dt>
                      <dd>
                        {data.result[0].work_order_from.wo_number
                          ? data.result[0].work_order_from.wo_number
                          : "-"}
                      </dd>

                      <dt>WO Sequence</dt>
                      <dd>
                        {data.result[0].work_order_from.wo_seq
                          ? data.result[0].work_order_from.wo_seq
                          : "-"}
                      </dd>

                      <dt>WO Description</dt>
                      <dd>
                        {data.result[0].work_order_from.wo_desc
                          ? data.result[0].work_order_from.wo_desc
                          : "-"}
                      </dd>

                      <dt>WO Destination name</dt>
                      <dd>
                        {data.result[0].work_order_from.wo_destination_name
                          ? data.result[0].work_order_from.wo_destination_name
                          : "-"}
                      </dd>

                      <dt>WO Address</dt>
                      <dd style={{ textAlign: "justify" }}>
                        {data.result[0].work_order_from.wo_address
                          ? data.result[0].work_order_from.wo_address
                          : "-"}
                      </dd>
                    </Col>
                    <Col md="6">
                      <h6>Time-related Information</h6>
                      <dt>Distance</dt>
                      <dd>
                        {data.result[0].work_order_from.distance
                          ? data.result[0].work_order_from.distance + " KM"
                          : "-"}
                      </dd>

                      <dt>Est. Departure Time</dt>
                      <dd>
                        {data.result[0].work_order_from.est_departure_time
                          ? this.dateFormatter(
                              data.result[0].work_order_from.est_departure_time
                            )
                          : "-"}
                      </dd>

                      <dt>Est. Arrival Time</dt>
                      <dd>
                        {data.result[0].work_order_from.est_arrival_time
                          ? this.dateFormatter(
                              data.result[0].work_order_from.est_arrival_time
                            )
                          : "-"}
                      </dd>

                      <dt>Check-in Time</dt>
                      <dd>
                        {this.dateFormatter(data.result[0].timeCheckIn)
                          ? this.dateFormatter(data.result[0].timeCheckIn)
                          : "-"}
                      </dd>

                      <dt>Check-out Time</dt>
                      <dd>
                        {this.dateFormatter(data.result[0].timeCheckOut)
                          ? this.dateFormatter(data.result[0].timeCheckOut)
                          : "-"}
                      </dd>
                    </Col>
                    <Col md="12">
                      {data.result[0].work_order_from.id_inbound_stocker ||
                      data.result[0].work_order_from.id_outbound_stocker ? (
                        <React.Fragment>
                          <dt>Delivery Item(s)</dt>
                          <dd>
                            <CheckOutboundItemTable
                              showTable={true}
                              idInboundStocker={
                                data.result[0].work_order_from
                                  .id_inbound_stocker
                              }
                              idOutboundStocker={
                                data.result[0].work_order_from
                                  .id_outbound_stocker
                              }
                              inboundItem={
                                woInboundData[
                                  data.result[0].work_order_from
                                    .id_inbound_stocker
                                ]
                                  ? woInboundData[
                                      data.result[0].work_order_from
                                        .id_inbound_stocker
                                    ]
                                  : null
                              }
                              outboundItem={
                                woOutboundData[
                                  data.result[0].work_order_from
                                    .id_outbound_stocker
                                ]
                                  ? woOutboundData[
                                      data.result[0].work_order_from
                                        .id_outbound_stocker
                                    ]
                                  : null
                              }
                            />
                          </dd>
                        </React.Fragment>
                      ) : null}
                    </Col>
                  </Row>
                  <br />
                  <Alert color="success" style={{ marginBottom: 0 }}>
                    <Row>
                      <Col md="6">
                        <dt>PIC Name</dt>
                        <dd>
                          {data.result[0].work_order_from.pic_name
                            ? data.result[0].work_order_from.pic_name
                            : "-"}
                        </dd>
                      </Col>
                      <Col md="6">
                        <dt>PIC Phone</dt>
                        <dd>
                          {data.result[0].work_order_from.pic_phone
                            ? data.result[0].work_order_from.pic_phone
                            : "-"}
                        </dd>
                      </Col>
                    </Row>
                  </Alert>
                </Card>
              );
            }
          }
        }
      });
    } else {
      // Status delivered or obsolete
      return (
        <Alert color="success">
          Your package delivery tracking link already obsolete. Please contact
          your supplier/logistic to verify delivery status. Thank you for
          trusting Automa ID as your one and only Supply Chain and Logistics
          Management Solution.
        </Alert>
      );
    }
  };

  render() {
    return (
      <div className="app flex-row align-items-center login-body">
        <Container>
          <Row className="justify-content-center">
            <Col md="9">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    <img
                      src={logoAutoma}
                      alt="Automa Logo"
                      className="automa-logo-login"
                      style={{ maxWidth: "5em", height: "auto", width: "4em" }}
                    />
                    <br />
                    <br />
                    <h4>Automa Transporter Tracker</h4>
                    <br />
                    {this.props.match.params.id ? (
                      this.props.inProgress ? (
                        <center>
                          <HashLoader
                            color={"#123abc"}
                            loading={this.props.inProgress}
                          />{" "}
                          <br /> Loading.... Please wait...
                        </center>
                      ) : this.props.success ? (
                        this.props.closed ? (
                          <Alert color="warning">
                            This tracker has been closed by our system for
                            safety reason! It means your item has been
                            delivered.
                          </Alert>
                        ) : (
                          this.checkDataShow()
                        )
                      ) : (
                        <center>
                          Error fetching your data... <br />
                          <br />
                          <Button
                            className="btn btn-primary"
                            color="primary"
                            size="md"
                            disabled={this.props.inProgress}
                            onClick={() =>
                              this.props.fetchTransporterShareTrack(
                                this.props.match.params.id
                              )
                            }
                          >
                            <i className="fa fa-refresh"></i>
                            Try again
                          </Button>
                        </center>
                      )
                    ) : (
                      <Alert color="success">
                        Your package delivery tracking link already obsolete.
                        Please contact your supplier/logistic to verify delivery
                        status. Thank you for trusting Automa ID as your one and
                        only only Supply Chain and Logistics Management
                        Solution.
                      </Alert>
                    )}
                  </CardBody>
                  <Row>
                    <Col md="12">
                      <span className="pull-right">
                        <a href="https://automa.id">Automa</a> &copy;{" "}
                        {this.updateYear()}
                      </span>
                    </Col>
                  </Row>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    transporterShareTrackData:
      state.transporterShareTrackStore.transporterShareTrackData,
    success: state.transporterShareTrackStore.success,
    driverVac: state.transporterShareTrackStore.driverVac,
    asstVac: state.transporterShareTrackStore.asstVac,
    closed: state.transporterShareTrackStore.closed,
    inProgress: state.transporterShareTrackStore.inProgress,

    woInboundData: state.woInboundItemDetailStore.woInboundData,
    woOutboundData: state.woOtuboundItemDetailStore.woOutboundData,
  };
};

export default connect(mapStateToProps, {
  fetchTransporterShareTrack,
  fetchWorkOrdersStockerInboundItemByWoTable,
  fetchWorkOrdersStockerOutboundItemByWoTable,
})(TrackerDetails);



// WEBPACK FOOTER //
// ./src/views/Transporter/Tracker/TrackerDetails.jsx